module.exports = {"TXTWCL_Resend_code":{"id":"TXTWCL_Resend_code","defaultMessage":"Kód újraküldése","track":"Resend code"}}